module.exports = __webpack_public_path__ + "img/banner_bg.91c0bff1.png";